export default {
  INDEXATION: "/indexation/{id}",
  INDEXATION_CREATION: "/indexation-creation",
  INDEXATIONS: "/indexations",
  STATUS: "/status",
};
